import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import ScanlineOverlay from './ScanlineOverlay';
import ParticleBackground from '../modules/ParticleBackground';
import styles from './Layout.module.css';

export default function Layout() {
  return (
    <div className={styles.layout}>
      <ParticleBackground />
      <ScanlineOverlay />
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
